import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';
import { colors } from '@shared/theme/colours';

import { styles } from './ArrowRight.styles';

export interface ArrowRightIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const ArrowRightIconComponent: FC<ArrowRightIconProps> = ({ classes, color = colors.white.lightest }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path
        d="M3.33325 8.87492H12.6666M12.6666 8.87492L7.99992 4.20825M12.6666 8.87492L7.99992 13.5416"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowRightIcon = withStyles(styles)(ArrowRightIconComponent);
